(() => {
  const popup = document.querySelector('[data-newsletter-popup]');
  if (!popup || !popup.showModal) return;
  const storageKey = 'relevant:newsletter:next-invitation';
  let previousFocus = null;
  let hasOpened = false;
  let waited = false;
  let canInvite = false;
  try { canInvite = Number(localStorage.getItem(storageKey) || 0) <= Date.now(); } catch { /* Keep automatic invitations off when storage is unavailable. */ }
  function deferInvitation() {
    canInvite = false;
    try { localStorage.setItem(storageKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000)); return true; } catch { return false; /* Manual invitations and dismissal still work without storage. */ }
  }
  function openPopup(trigger) {
    if (popup.open || document.querySelector('#CartDrawer[open]')) return;
    previousFocus = trigger || document.activeElement;
    popup.showModal();
    document.body.classList.add('newsletter-is-open');
    hasOpened = true;
    deferInvitation();
    popup.querySelector('[data-newsletter-close]')?.focus();
  }
  function considerInvitation() {
    if (!waited || !canInvite || hasOpened || popup.dataset.autoOpen !== 'true') return;
    if (!matchMedia('(min-width: 761px)').matches || document.visibilityState !== 'visible') return;
    if (document.activeElement?.matches('input, textarea, select') || document.querySelector('dialog[open], [data-product-form][aria-busy="true"]')) return;
    const availableScroll = document.documentElement.scrollHeight - innerHeight;
    if (availableScroll <= 0 || scrollY / availableScroll < 0.45) return;
    // Recheck other tabs and persist the cooldown before any automatic interruption.
    try { if (Number(localStorage.getItem(storageKey) || 0) > Date.now()) { canInvite = false; return; } } catch { canInvite = false; return; }
    if (!deferInvitation()) return;
    openPopup();
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const trigger = target.closest('[data-newsletter-open]');
    if (trigger) {
      if (trigger.tagName === 'A' && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
      event.preventDefault(); openPopup(trigger); return;
    }
    if (target.closest('[data-newsletter-close]')) { popup.close(); return; }
    if (target === popup) {
      const bounds = popup.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
    }
  });
  popup.addEventListener('close', () => {
    document.body.classList.remove('newsletter-is-open');
    deferInvitation();
    if (previousFocus?.isConnected) previousFocus.focus();
  });
  addEventListener('scroll', considerInvitation, {passive:true});
  setTimeout(() => { waited = true; considerInvitation(); }, Math.max(10, Number(popup.dataset.delay) || 25) * 1000);
  if (popup.querySelector('[data-popup-result]') && location.hash === '#NewsletterPopupForm') openPopup();
})();
